export default __webpack_public_path__ + "static/media/food07.335fa287.png";